export default () =>
  import(/* webpackChunkName: 'coffee/app/help-centre/store' */ './HelpCentre');
